import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import classNames from 'classnames';
import styles from 'assets/jss/material-dashboard-pro-react/components/customNavigationButtonsStyle';
import { translate } from 'components/Translation';
import { hasPermission } from 'utils/permissions/permissions';
import { userTypeSelector } from 'redux/modules/session/selectors';
import { BodyS } from 'components/Typography/Typography';

export interface ITab {
	value: string;
	icon: any;
	disabled?: boolean;
	action?: string;
	id?: string;
}

interface INavigationButtons {
	className?: string;
	value: string;
	path: string;
	tabs: ITab[];
	props?: any;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const CustomNavigationButtons = ({ tabs, value = 'all', className, path, props }: INavigationButtons) => {
	const classes = useStyles();
	const [active, setActive] = useState(value);
	const [availableTabs, setAvailableTabs] = useState<ITab[]>([]);
	const userType = useSelector(userTypeSelector);
	const theme = useTheme();
	const withScroll = useMediaQuery(theme.breakpoints.down('sm'));
	const variant = withScroll ? 'scrollable' : 'standard';

	const history = useHistory();
	const goTo = (filterBy: string) => {
		// added to show aamali+services, in case of micro bundle when the route changes
		// accountCategory is used as an identifier for microbundle
		const accountCategory = props?.accountCategory;
		if (accountCategory) {
			return history.push({
				pathname: `${path}/${filterBy}`,
				search: `?accountCategory=${accountCategory}`,
			});
		}
		history.push({ pathname: `${path}/${filterBy}`, search: location.search });
	};

	useEffect(() => {
		setActive(value);
	}, [value]);

	useEffect(() => {
		if (tabs.length) setAvailableTabs(tabs.filter(({ action = 'all' }) => hasPermission(userType, action)));
	}, [tabs, userType]);

	const filterTabs = classNames({
		[classes.tabs]: true,
	});
	const filterTab = classNames({
		[classes.tab]: true,
	});

	const label = (value: string) => {
		const key = value.replace('-', '.');
		return translate(`path.${key}`);
	};

	return (
		<div className={className}>
			<Tabs value={active} className={filterTabs} variant={variant} scrollButtons="off">
				{availableTabs.map((prop, key) => {
					return (
						<Tab
							label={<BodyS color="brand">{label(prop.value)}</BodyS>}
							value={prop.value}
							key={key}
							disabled={prop.disabled}
							onClick={() => goTo(prop.value)}
							icon={<prop.icon />}
							className={filterTab}
							id={prop.id}
						/>
					);
				})}
			</Tabs>
		</div>
	);
};

export default CustomNavigationButtons;
